import dayjs from 'dayjs'
import { ScheduleDescriptionProps } from './Types'
import { PostingCadence } from '../../ScheduleContent'

const ScheduleDescription = ({ postingCadence, customDays, startDate }: ScheduleDescriptionProps) => {
  switch (postingCadence) {
    case PostingCadence.Once:
      return <>Post once per week on {startDate.format('dddd')}</>
    case PostingCadence.Twice:
      return <>Post twice per week on Tue & Thu</>
    case PostingCadence.Thrice:
      return <>Post three times per week on Mon, Wed & Fri</>
    case PostingCadence.Weekdays:
      return <>Post every weekday</>
    case PostingCadence.Everyday:
      return <>Post every day</>
    case PostingCadence.Custom:
      if (customDays.length === 7) {
        return <>Post every day</>
      }

      let postOn = ''
      if (customDays.length === 1) {
        postOn = dayjs().day(customDays[0].day).format('dddd')
      }
      if (customDays.length === 2) {
        postOn = customDays.map((dayAndTime) => dayjs().day(dayAndTime.day).format('ddd')).join(' & ')
      }

      if (customDays.length > 2 && customDays.length < 7) {
        postOn = customDays
          .slice(0, customDays.length - 1)
          .map((dayAndTime) => dayjs().day(dayAndTime.day).format('ddd'))
          .join(', ')
        postOn = `${postOn} & ${dayjs()
          .day(customDays[customDays.length - 1].day)
          .format('ddd')}`
      }
      return <>Post on {postOn}</>
  }
}

export { ScheduleDescription }
